import "@/App.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Products } from "@/components/site/Products";
import { FAQ } from "@/components/site/FAQ";
import { Marquee } from "@/components/site/Marquee";
import { Share } from "@/components/site/Share";
import { Contact } from "@/components/site/Contact";

function App() {
  return (
    <SmoothScroll>
      <div className="App grain" data-testid="app-root">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Products />
          <Manifesto />
          <FAQ />
          <Share />
          <Contact />
        </main>
      </div>
    </SmoothScroll>
  );
}

export default App;
